import {BaseReference} from "../../model/BaseReference";
import {NocoDbProjectProxy} from "../NocoDbProjectProxy";
import {IListingReponse} from "../ListingReponse";
import {ITypeEnum} from "../../model/Question";


export interface INocoEnumeratedType {

  Id: number;
  Description: string;
  ProductId: number;
  SpreadsheetRow: number|null;
}


export class NocoEnumeratedType extends BaseReference<INocoEnumeratedType> {

  protected onSetValue(value: INocoEnumeratedType | null) {
  }

  constructor( value: INocoEnumeratedType | null ) {

    super( value );

    if ( value ) {
      this.value = value;
    }
  }
}


export class NocoEnumeratedTypeSet {

  enumeratedTypes: NocoEnumeratedType[] = [];
  enumeratedTypesById: {[id: number]: NocoEnumeratedType} = {};




  public static async getValue( proxy: NocoDbProjectProxy ): Promise<IListingReponse<INocoEnumeratedType>> {

    return proxy.getView<INocoEnumeratedType>( 'EnumeratedType' );;
  }


  public static async build( proxy: NocoDbProjectProxy ): Promise<NocoEnumeratedTypeSet> {

    const value = await NocoEnumeratedTypeSet.getValue( proxy );
    return new NocoEnumeratedTypeSet( value );
  }


  public constructor( public value: IListingReponse<INocoEnumeratedType> ) {

    for( const rowValue of value.list ) {

      const reference = new NocoEnumeratedType( rowValue );
      this.enumeratedTypes.push( reference );
      this.enumeratedTypesById[rowValue.Id] = reference;
    }

  }


}
